import styled from 'styled-components'
import Container from './Container'

const ReadingInset = styled(Container)`
  max-width: 800px;
  padding: 0;
`

export default ReadingInset
